import { ReduxTypes } from 'app/store/redux';
import * as constants from 'app/modules/analytics/redux/analyticsActionsConstants';
import * as actions from 'app/modules/analytics/redux/analyticsActions';
import { AnalyticsReducerState } from 'app/modules/analytics/analyticsTypes';
import { ANALYTICS_COOKIE_PERMISSION_KEY, MARKETING_COOKIE_PERMISSION_KEY, IS_USER_SET_COOKIE_SETTINGS } from 'app/modules/analytics/analyticsConstants';
import { readBooleanFromLocalStorage } from 'app/selectors/Helpers';

const initialState: AnalyticsReducerState = {
	cookieSettings: {
		isAnalyticsCookieAllowed: readBooleanFromLocalStorage(ANALYTICS_COOKIE_PERMISSION_KEY) ?? true,
		isMarketingCookieAllowed: readBooleanFromLocalStorage(MARKETING_COOKIE_PERMISSION_KEY) ?? true,
	},
	isUserSetCookieSettings: !!localStorage.getItem(IS_USER_SET_COOKIE_SETTINGS)
};

const analyticsReducer = (
	state = initialState,
	action: ReturnType<ReduxTypes.InferValueTypes<typeof actions>>
): AnalyticsReducerState => {
	switch (action.type) {
		case constants.SET_USER_COOKIE_SETTINGS:
			return {
				...state,
				cookieSettings: action.payload.cookieSettings,
				isUserSetCookieSettings: true
			}
		default:
			return state;
	}
}

export default analyticsReducer